import { render } from "./CustomerDetail.vue?vue&type=template&id=22009205&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"

import "./styles/CustomerDetail.scss?vue&type=style&index=0&id=22009205&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22009205"]])

export default __exports__